<div class="field-title-wrapper">
  <div class="mandatory-label" 
    *ngIf="isInput && !fieldDefinition.is_nullable">
    *
  </div>
  <div class="title">
    {{fieldDefinition.name}}
  </div>
</div>